import React, { useCallback } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';
import Radio from './Radio';

export interface Option {
  label: string;
  value: any;
}

interface Props<T extends Option> {
  name: string;
  options: T[];
  value: T['value'];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (val: string | undefined) => void;
  className?: string;
  radioClassName?: string;
}

export default function (props: Props<Option>) {
  const { options, name, value, onChange, onClick, radioClassName, className } =
    props;
  const handleChangeRadio = useCallback(
    function (checked, e) {
      if (checked && onChange) {
        onChange(e);
      }
    },
    [onChange]
  );

  return (
    <div className={cn(styles.radioGroup, className)}>
      {options.map((item, index) => (
        <Radio
          {...item}
          key={index}
          name={name}
          className={radioClassName}
          checked={value === item.value}
          onChange={handleChangeRadio}
          onClick={onClick}
        />
      ))}
    </div>
  );
}
